import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { ElMessage, ElLoading } from "element-plus"
//import { useRouter } from 'vue-router'
import { RequestConfig, RequestInterceptors } from "./types"
import router from '@/router'

//const router = useRouter(); // 不能在这里面使用userRouter()  router获取为undefined
var loadingInstance: any = null
class Request {
    //axios实例
    instance: AxiosInstance
    //拦截器对象
    interceptorsObj?: RequestInterceptors

    constructor(config: RequestConfig) {
        //创建实例
        this.instance = axios.create(config)

        //类请求拦截器
        this.instance.interceptors.request.use((req: AxiosRequestConfig) => {
            // loadingInstance = ElLoading.service()
            let token = localStorage.getItem('token');
            // let token = store.getters.getToken;
            if (token) {//如果有token给请求头加上
                req.headers['Authorization'] = `Bearer ${token}`
            }
            return req
        }, (err: any) => {
            console.log(err);
        })

        //使用实例请求拦截器
        this.instance.interceptors.request.use(
            this.interceptorsObj?.requestInterceptors,
            this.interceptorsObj?.requestInterceptorsCatch
        )
        //使用实例响应拦截器
        this.instance.interceptors.response.use(
            this.interceptorsObj?.responseInterceptors,
            this.interceptorsObj?.responseInterceptorsCatch
        )

        //类响应拦截器
        this.instance.interceptors.response.use((res: AxiosResponse) => {
            // loadingInstance.close()
            return res.data
        }, (err: any) => {
            if (err.response) {
                let { status } = err.response
                switch (status) {
                    case 401:
                        ElMessage.warning('登录信息已失效，请重新登录!')
                        localStorage.removeItem('token')
                        router.push({ path: '/login' })
                        //window.location.href = "/login"
                        break
                    default:
                }
                let { Code } = err.response.data
                switch (Code) {
                    case 401:
                        ElMessage.warning('登录信息已失效，请重新登录!')
                        localStorage.removeItem('token')
                        router.push({ path: '/login' })
                        //window.location.href = "/login"
                        break
                    default:
                }
            } else {
                ElMessage.error('服务器错误')
            }

        })
    }

    request<T>(config: RequestConfig): Promise<T> {
        return new Promise((resolve, reject) => {
            if (config.interceptors?.requestInterceptors) {
                config = config.interceptors.requestInterceptors(config)
            }
            this.instance
                .request<any, T>(config)
                .then(res => {
                    // 如果我们为单个响应设置拦截器，这里使用单个响应的拦截器
                    if (config.interceptors?.responseInterceptors) {
                        res = config.interceptors.responseInterceptors<T>(res)
                    }
                    resolve(res)
                })
                .catch((err: any) => {
                    console.log("-----", err);
                    reject(err)
                })
        })
    }
}

export default Request